import React from 'react';
import { FactFindForm } from '@/components/forms/FactFindForm';

export const RiskTab = () => {
	return (
		<>
			<FactFindForm title={'Risk Info'} factFindType={'risk'} />
		</>
	);
};
